export enum HeatmapSizeEnum {
  Small,
  Large,
}
